/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';
import { TerminalPending } from './../model/terminal-pending.model';

/**
 * @export
 * @class AddToPendingService
 */
@Injectable()
export class AddToPendingService {
  private handleTermialPL: TerminalPending;
  private terminalPL: Subject<TerminalPending>;
  private enablePendingList: Subject<Boolean>;

  terminalPL$: Observable<Object>;
  enablePendingList$: Observable<Boolean>;

  /**
   * Creates an instance of AddToPendingService.
   *
   * @memberOf AddToPendingService
   */
  constructor() {
    const terminalPL = {
      pendingList: []
    };
    this.handleTermialPL = terminalPL;
    this.terminalPL = new Subject();
    this.terminalPL.next(terminalPL);
    this.terminalPL$ = this.terminalPL.asObservable();


    this.enablePendingList = new Subject();
    this.enablePendingList.next(false);
    this.enablePendingList$ = this.enablePendingList.asObservable();


    this.terminalPL$.subscribe(data => {
      this.handleTermialPL = <TerminalPending>data;
    });
  }

  /**
   * @param {any} PendingListData
   *
   * @memberOf AddToPendingService
   */
  updatePendingListData(PendingListData) {
    this.terminalPL.next(PendingListData);
  }

  /**
   * @param {Boolean} status
   *
   * @memberOf AddToPendingService
   */
  updatePendingListStatus(status: Boolean) {
    this.enablePendingList.next(status);
  }

  /**
   * @param {any} trainData
   * @param {string} action
   * @param {string} [terminal]
   * @param {string} [road]
   * @param {string} [planLoco]
   *
   * @memberOf AddToPendingService
   */
  addInPendingList(trainData, action: string, terminal?: string, road?: string, planLoco?: string, contextMenuOperation?: any, submitAfterAddInPendingList?: boolean) {
    let matchResequence = false;
    if (!this.handleTermialPL || !this.handleTermialPL.pendingList) {
      const terminalPL = {
        pendingList: []
      };
      this.handleTermialPL = terminalPL;
    }
    if (action === 'resequence' && this.handleTermialPL.pendingList.length) {
      for (let i = 0; i < this.handleTermialPL.pendingList.length; i++) {
        const pendingList = this.handleTermialPL.pendingList;
        if (pendingList[i].action === 'resequence' && pendingList[i].trains[0].trainIdentifier === trainData['trains'][0].trainIdentifier) {
          pendingList[i].trains[0] = trainData['trains'][0];
          const locos = trainData['trains'][0].locoDetails;
          matchResequence = true;
        }
      }
    }
    if (!matchResequence) {
      this.handleTermialPL.pendingList.push({
        trains: trainData['trains'],
        locos: trainData.locos,
        index: this.handleTermialPL.pendingList.length,
        action: action,
        terminal: terminal ? terminal : '',
        hasError: false,
        road: road ? road : '',
        planLoco: planLoco ? planLoco : '',
        errorMessage: '',
        contextMenuOperation: contextMenuOperation ? contextMenuOperation : {},
        submitPendingList: submitAfterAddInPendingList ? true : false
      });
    }
    this.updatePendingListData(this.handleTermialPL);
  }

  /**
   * @memberOf AddToPendingService
   */
  resetAll() {
    this.handleTermialPL.pendingList = [];
    this.updatePendingListData(this.handleTermialPL);
  }

  /**
   * @param {Array<string>} reminingData
   * @memberOf AddToPendingService
   */
  deleteInPendingList(reminingData) {
    this.handleTermialPL.pendingList = reminingData;
    this.updatePendingListData(this.handleTermialPL);
  }

  /**
   * @private
   * @param {any} locos
   * @returns
   *
   * @memberOf AddToPendingService
   */
  private sortLoco(locos) {
    locos.sort((a, b) => {
      if (a.resequenceOrder < b.resequenceOrder) {
        return -1;
      }
      if (a.resequenceOrder > b.resequenceOrder) {
        return 1;
      }
      if (a.resequenceOrder === b.resequenceOrder) {
        return 0;
      }
    });
    return locos;
  }

}
